module.exports = __webpack_public_path__ + "media/images/photo-blog-7686e1a7515d0c134f25e9d415347d17.jpg";